import React from 'react';
import { FiStar } from 'react-icons/fi';
import { format } from 'date-fns';

interface NoDataStateProps {
  title?: string;
  description?: string;
  startDate?: Date;
  endDate?: Date;
  icon?: React.ReactNode;
  iconSize?: 'sm' | 'md' | 'lg' | 'xl';
  iconContainerClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  dateRangeClassName?: string;
  className?: string;
}

export const NoDataState: React.FC<NoDataStateProps> = ({
  title = "No Data Available",
  description = "No data found for the selected date range. Try adjusting your date range or check back later when more data becomes available.",
  startDate,
  endDate,
  icon,
  iconSize = 'lg',
  iconContainerClassName = "bg-gradient-to-br from-gray-50 to-gray-100 rounded-full p-6 mb-4",
  titleClassName = "text-lg font-semibold text-gray-700 mb-2",
  descriptionClassName = "text-gray-500 max-w-md leading-relaxed",
  dateRangeClassName = "mt-4 px-4 py-2 bg-blue-50 border border-blue-200 rounded-lg",
  className = ""
}) => {
  const iconSizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12', 
    lg: 'w-16 h-16',
    xl: 'w-20 h-20'
  };

  const defaultIcon = <FiStar className={`${iconSizeClasses[iconSize]} text-gray-400`} />;

  return (
    <div className={`flex flex-col items-center h-full justify-center py-24 text-center ${className}`}>
      <div className={iconContainerClassName}>
        {icon || defaultIcon}
      </div>
      <h3 className={titleClassName}>
        {title}
      </h3>
      <p className={descriptionClassName}>
        {description}
      </p>
      {startDate && endDate && (
        <div className={dateRangeClassName}>
          <p className="text-sm text-blue-700">
            📅 Selected period: {format(startDate, 'MMM dd, yyyy')} to {format(endDate, 'MMM dd, yyyy')}
          </p>
        </div>
      )}
    </div>
  );
};

export default NoDataState;
